/**
 * Laravel validation payload: { message?, errors?: { "field.key": ["msg"] } }
 */

export function flattenLaravelErrors(errors) {
  if (!errors || typeof errors !== "object") return [];
  const out = [];
  for (const key of Object.keys(errors)) {
    const val = errors[key];
    if (Array.isArray(val)) {
      val.forEach((m) => {
        if (typeof m === "string" && m.trim()) out.push(`${key}: ${m}`);
      });
    } else if (typeof val === "string" && val.trim()) {
      out.push(`${key}: ${val}`);
    }
  }
  return out;
}

/** First human-readable line for toast / banner. */
export function firstLaravelErrorMessage(errors) {
  const lines = flattenLaravelErrors(errors);
  return lines.length ? lines[0].replace(/^[^:]+:\s*/, "") : null;
}

/**
 * Prefer first validation line; else `message`.
 */
export function resolveApiPayloadMessage(payload) {
  if (!payload || typeof payload !== "object") return null;
  const fromErrors = firstLaravelErrorMessage(payload.errors);
  if (fromErrors) return fromErrors;
  if (typeof payload.message === "string" && payload.message.trim()) {
    return payload.message.trim();
  }
  const flat = flattenLaravelErrors(payload.errors);
  return flat.length ? flat[0].replace(/^[^:]+:\s*/, "").trim() : null;
}

/**
 * Axios error — validation errors first, then message, then generic.
 */
export function resolveAxiosErrorMessage(error) {
  const data = error?.response?.data;
  if (data && typeof data === "object") {
    const fromErrors = firstLaravelErrorMessage(data.errors);
    if (fromErrors) return fromErrors;
    const m = resolveApiPayloadMessage(data);
    if (m) return m;
  }
  if (typeof error?.message === "string" && error.message) {
    return error.message;
  }
  return null;
}

export const CHECK_FARE_TOAST_ID = "booking-check-fare-error";
